const { v4: uuidv4 } = require('uuid');
const ItemGenerator = require('../models/game_items/ItemGenerator');

const THIRTY_HOURS_MS = 30 * 60 * 60 * 1000;
const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

const Balance = {
  getXPForLevel: (level) => {
    return level <= 50
      ? XP_PER_LEVEL[level]
      : Math.round(Balance.getXPForLevel(50) + Math.pow(level, 5.45) - 1.83 * 1000 * 1000 * 1000);
  },

  NUM_STARTER_ITEMS: 5,
  MAX_GLOBAL_BAG_SLOTS: 5,
  MAX_HERO_BAG_SLOTS: 3,

  // abilities
  MAX_ABILITY_LEVEL: 10,
  ABILITY_POINTS_PER_LEVEL: 2,
  ABILITY_UPGRADE_COST: 1, // ability point

  // affinities
  AFFINITIES_UNLOCK_LEVEL: 30,
  AFFINITY_UPGRADE_COST: 1, // ability point
  AFFINITY_BONUS_PER_POINT: 0.04,
  MAX_ATTACK_AFFINITY_LEVEL: 25,
  MAX_DEFENSE_AFFINITY_LEVEL: 15,

  // attributes
  MAX_ATT_LEVEL: 50,
  ATT_POINTS_PER_LEVEL: 3,

  MAX_HERO_BUILDS: 7,

  getAttUpgradeCost: (currentValue) => {
    return Math.max(1, Math.floor(currentValue / 5));
  },

  CONJURATION_RANGE: 5,
  CRITICAL_STRIKE_MOD: 1.5,

  // caverns
  CHANCE_TO_SPAWN_STAIRS: 0.35,

  getEloKFactor(player_rating, is_live) {
    let base = 23;

    if (player_rating <= 1600) {
      base = 40;
    } else if (player_rating <= 1850) {
      base = 34;
    } else if (player_rating <= 2100) {
      base = 29;
    } else if (player_rating <= 2350) {
      base = 25;
    }

    return is_live ? base : Math.round(base / 2);
  },

  getDmgReduxFromArmorClass: (ac) => 0.9 * Math.tanh(0.0044 * ac),

  MAX_ALTAR_LEVEL: 10,
  MAX_CAVERNS_LEVEL: 100,

  XP_MODS_BY_GAME_MODE: {
    GAME_MODE_caverns: 0.5,
    GAME_MODE_pvpAuto: 0.25,
    GAME_MODE_pvpLive: 0.25,
  },

  BATTLES_PER_LEVEL: [
    /*0*/ 0, // total battles: 0
    /*1*/ 1, // total battles: 1
    /*2*/ 3, // total battles: 3
    /*3*/ 3, // total battles: 6
    /*4*/ 4, // total battles: 10
    /*5*/ 5, // total battles: 15
    /*6*/ 5, // total battles: 20
    /*7*/ 10, // total battles: 30
    /*8*/ 10, // total battles: 40
    /*9*/ 15, // total battles: 55
    /*10*/ 15, // total battles: 70 // day 1
    /*11*/ 15, // total battles: 95
    /*12*/ 15, // total battles: 110
    /*13*/ 15, // total battles: 125
    /*14*/ 15, // total battles: 140
    /*15*/ 20, // total battles: 160
    /*16*/ 20, // total battles: 180 // day 2
    /*17*/ 20, // total battles: 200
    /*18*/ 20, // total battles: 220
    /*19*/ 20, // total battles: 240
    /*20*/ 20, // total battles: 260
    /*21*/ 25, // total battles: 285 // day 3
    /*22*/ 25, // total battles: 310
    /*23*/ 25, // total battles: 335
    /*24*/ 25, // total battles: 360 // day 4
    /*25*/ 30, // total battles: 390
    /*26*/ 35, // total battles: 425
    /*27*/ 40, // total battles: 465 // day 5
    /*28*/ 45, // total battles: 510
    /*29*/ 50, // total battles: 560 // day 6
    /*30*/ 60, // total battles: 620
    /*31*/ 70, // total battles: 690 // day 7
    /*32*/ 85, // total battles: 775
    /*33*/ 100, // total battles: 875
    /*34*/ 125, // total battles: 1000
    /*35*/ 150, // total battles: 950
    /*36*/ 150, // total battles: 1,110
    /*37*/ 200, // total battles: 1,300 // day 14
    /*38*/ 250, // total battles: 1,550
    /*39*/ 300, // total battles: 1,850
    /*40*/ 350, // total battles: 2,200
    /*41*/ 500, // total battles: 2,700 // day 30
    /*42*/ 900, // total battles: 3,600
    /*43*/ 900, // total battles: 4,500
    /*44*/ 1000, // total battles: 5,500 // day 60
    /*45*/ 1200, // total battles: 6,700
    /*46*/ 1300, // total battles: 8,000 // day 90
    /*47*/ 1400, // total battles: 9,400
    /*48*/ 1400, // total battles: 10,800 // day 120
    /*49*/ 2700, // total battles: 13,500 // day 150
    /*50*/ 2700, // total battles: 16,200 // day 180
  ],

  getCavernsPassiveYieldXPPot: ({ caverns_data, game_submode }) => {
    const { deepest_level, last_passive_yield_claim } = caverns_data[game_submode];
    const claim_delta = Date.now() - last_passive_yield_claim;
    const bonus = 0.1 + 0.007 * deepest_level;
    const hours = 0.1 + 23.9 * Math.min(1, claim_delta / THREE_DAYS_MS); // 6 mins ~ 1 day

    return {
      duration: hours * 60 * 60 * 1000,
      pd_price: Math.round(bonus * (hours * 24) * 75),
      type: 'hero_xp_boost',
      uid: uuidv4(),
      xp_bonus: bonus,
    };
  },

  getInnCompletionRewards({ do_upgrade, do_downgrade, tier }) {
    return do_upgrade
      ? {
          // great shit
          gold: Math.round(tier * 300 + Math.pow(tier, 4)),
          items: (() => {
            const result = {};
            const num_items = Math.floor(Math.random() * 4); // 0~3 items
            for (let i = 0; i < num_items; ++i) {
              const maxQuality = Math.min(
                1,
                Math.max(0, tier / Balance.MAX_INN_TOURNEY_TIER - 0.1 + Math.random() * 0.2)
              );
              const item = ItemGenerator.getRandomItem(null, maxQuality / 2, maxQuality);
              result[item.uid] = item;
            }
            return result;
          })(),
          pixieDust: Math.ceil(Math.random() * 3),
        }
      : do_downgrade
        ? {
            // shitty shit
            gold: Math.round(tier * 100 + Math.pow(tier, 1.6)),
            // items: {},
            pixieDust: 0,
          }
        : {
            // mediocre shit
            gold: Math.round(tier * 200 + Math.pow(tier, 3.2)),
            items: (() => {
              const maxQuality = Math.min(
                1,
                Math.max(0, tier / Balance.MAX_INN_TOURNEY_TIER - 0.1 + Math.random() * 0.2)
              );
              const item = ItemGenerator.getRandomItem(null, maxQuality / 2, maxQuality);
              return {
                [item.uid]: item,
              };
            })(),
            pixieDust: 0,
          };
  },

  getInnPeanutsPerMSByRank(rank) {
    return Math.max(0.001, 0.001 + 0.1 - rank * 0.001);
  },

  getInnUpgradeConditionByTier(tier) {
    // roughly ... be to this rank by the 12-hour mark
    // tier 1: 50
    // tier 2: 45
    // tier 3: 40
    // tier 4: 35
    // tier 5: 30
    // tier 6: 25
    // tier 7: 20
    // tier 8: 15
    // tier 9: 10
    // tier 10: xxx

    const critical_rank = 55 - tier * 5;
    const critical_ppms = Balance.getInnPeanutsPerMSByRank(critical_rank);
    return (critical_ppms * THIRTY_HOURS_MS).toFixed(0);
  },

  getInnMaintainConditionByTier(tier) {
    // roughly ... be to this rank by the 12-hour mark
    // tier 1: xxx
    // tier 2: 74
    // tier 3: 71
    // tier 4: 68
    // tier 5: 65
    // tier 6: 62
    // tier 7: 59
    // tier 8: 56
    // tier 9: 53
    // tier 10: 50

    const critical_rank = 80 - tier * 4;
    const critical_ppms = Balance.getInnPeanutsPerMSByRank(critical_rank);
    return (critical_ppms * THIRTY_HOURS_MS).toFixed(0);
  },

  MAX_INN_TOURNEY_TIER: 10,
  MIN_INN_TOURNEY_TIER: 1,
  MAX_INN_TOURNAMENT_PLAYERS: 100,
};

// caverns progression spreadsheet:
// https://docs.google.com/spreadsheets/d/1tYJ1U5_R-4YdoWsRwJWsh81xRdqlBJw8WBfROyNR5tM/edit?gid=0#gid=0
const XP_PER_LEVEL = [
  0, 100, 106, 116, 130, 150, 190, 250, 370, 490, 670, 990, 1390, 1810, 2510, 3560, 4960, 6610,
  8590, 11670, 15520, 20720, 26960, 36320, 50620, 81420, 117420, 165020, 229020, 372020, 585145,
  859870, 1214620, 1724620, 2408620, 3266620, 5016620, 7020020, 9293620, 13187620, 18302620,
  24932620, 33557620, 49352620, 68822620, 93932620, 132740620, 182816620, 253196620, 376172620,
  532172620,
];

module.exports = Balance;
